// NPM Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// Actions
import zone from '../../../../redux/actions/zone';
// Material-UI
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
// Material-UI List
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader';
// Material-UI Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// Material-UI Icons
import ExtensionRoundedIcon from '@material-ui/icons/ExtensionRounded';
/**
 * Zones Component
 */
class Zones extends Component {
  /**
   * component state
   */
  state = {
    search: ''
  };
  /**
   * componentDidMount
   */
  componentDidMount() {
    this.getZoneList();
  }
  /**
   * Calls zone.list.get action
   * @param {string} search
   */
  getZoneList(search = '') {
    this.props.getZoneList({
      org_key: this.props.org_key,
      page_size: 100,
      status: 'active',
      zone_type: this.props.DataPointType.substring(
        4,
        this.props.DataPointType.length - 1
      ).toLowerCase(),
      search
    });
  }
  /**
   *
   * @param {*} zone
   */
  handleDataPointAdd(zone) {
    this.props.onAdd({
      metadata: { ...zone },
      dataPoint: {
        zone_key: zone.zone_key,
        label: zone.zone_name,
        color: zone.color,
        interval: this.props.interval,
        threshold: this.props.threshold,
        start: this.props.startDateTime,
        end: this.props.endDateTime,
        timezone: this.props.timezone
      }
    });
  }
  /**
   *
   * @param {*} dataPoint
   */
  handleDataPointRemove(dataPoint) {
    this.props.onRemove(dataPoint.id);
  }
  /**
   * Debounce func for dealing with input delay
   * @param {*} fn
   * @param {*} time
   * @returns
   */
  debounce = (fn, time) => {
    let timeout;
    return function () {
      const functionCall = () => fn.apply(this, arguments);
      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    };
  };
  /**
   *
   */
  updateSearch = this.debounce(search => {
    this.setState({ search });
    this.getZoneList(search);
  }, 500);
  /**
   *
   * @param {*} param0
   */
  handleSearchUpdate = ({ target }) => {
    this.updateSearch(target.value);
  };
  /**
   * Returns a list of zones that
   * @returns {*}
   */
  generateNonDataPointZoneList() {
    const filteredZones = this.props.list.filter(zone =>
      this.props.dataPoints.find(
        dataPoint => dataPoint.zone_key === zone.zone_key
      )
        ? false
        : true
    );

    const zoneList = {};

    filteredZones.forEach(item => {
      zoneList[item.deployment_key] = {
        zones: zoneList[item.deployment_key]
          ? [...zoneList[item.deployment_key].zones, item]
          : [item],
        info: {
          deployment_name: item.deployment_name,
          deployment_key: item.deployment_key
        }
      };
    });

    return zoneList;
  }
  /**
   * render
   */
  render() {
    const { zones, open, dataPoints, onClose } = this.props;
    const zoneList = this.generateNonDataPointZoneList();
    const dataPointDeployments = {};
    dataPoints.forEach(dp => {
      dataPointDeployments[zones[dp.zone_key].deployment_key] =
        zones[dp.zone_key].deployment_name;
    });

    return (
      <Dialog open={open} onClose={onClose} fullWidth>
        <DialogTitle>
          Select data points to display
          <TextField
            label="Search Data Points"
            fullWidth
            autoFocus
            defaultValue={this.state.search}
            onChange={this.handleSearchUpdate}
          />
        </DialogTitle>
        <DialogContent>
          <List>
            {Object.entries(dataPointDeployments).map(
              ([deployment_key, deployment_name]) => (
                <List
                  key={deployment_key}
                  subheader={
                    <ListSubheader component="div" disableSticky>
                      {deployment_name}
                    </ListSubheader>
                  }
                >
                  {dataPoints
                    .filter(
                      dataPoint =>
                        zones[dataPoint.zone_key].deployment_key ===
                        deployment_key
                    )
                    .map(dataPoint => (
                      <ListItem
                        key={dataPoint.id}
                        dense
                        button
                        onClick={() => this.handleDataPointRemove(dataPoint)}
                      >
                        <ListItemIcon>
                          <ExtensionRoundedIcon
                            style={{
                              color: `rgb(${dataPoint.color.toString()})`
                            }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={`${zones[dataPoint.zone_key].zone_name} (${
                            zones[dataPoint.zone_key].zone_key
                          })`}
                          secondary={`${
                            zones[dataPoint.zone_key].array_name
                          } (${zones[dataPoint.zone_key].array_key})`}
                        />
                        <Checkbox color="primary" checked />
                      </ListItem>
                    ))}
                </List>
              )
            )}
            {dataPoints.length === 0 ? (
              <Typography variant="subtitle1">No points selected.</Typography>
            ) : null}
          </List>
          <Divider />
          {Object.keys(zoneList).length === 0 ? (
            <List>
              <ListItem dense>
                <ListItemText primary={'No Zones Found'} />
              </ListItem>
            </List>
          ) : null}
          {Object.values(zoneList).map(deployment => (
            <List
              key={deployment.info.deployment_key}
              subheader={
                <ListSubheader component="div" disableSticky>
                  {deployment.info.deployment_name}
                </ListSubheader>
              }
            >
              {Object.values(deployment.zones).map(zone => (
                <ListItem
                  key={zone.zone_key}
                  dense
                  button
                  onClick={() => this.handleDataPointAdd(zone)}
                  style={{ paddingLeft: '16px' }}
                >
                  <ListItemIcon>
                    <ExtensionRoundedIcon
                      style={{ color: `rgb(${zone.color.toString()})` }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={`${zone.zone_name} (${zone.zone_key})`}
                    secondary={`${zone.array_name} (${zone.array_key})`}
                  />
                  <Checkbox color="primary" disableRipple />
                </ListItem>
              ))}
            </List>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }
  /**
   * propTypes
   */
  static propTypes = {
    open: PropTypes.bool,
    dataPoints: PropTypes.array,
    onAdd: PropTypes.func,
    onClose: PropTypes.func,
    onRemove: PropTypes.func
  };
  /**
   * propTypes.defaultProps
   */
  static defaultProps = {
    open: false,
    dataPoints: [],
    onAdd: () => {},
    onClose: () => {},
    onRemove: () => {}
  };
  /**
   * static mapStateToProps
   * Maps the redux state to the component state.
   * @param {object} state redux state
   * @return {object} object of redux states
   */
  static mapStateToProps(state, props) {
    return {
      // Zone List
      list: state.zone.list.list,
      page: state.zone.list.page,
      count: state.zone.list.count,
      error: state.zone.list.error,
      status: state.zone.list.status,
      fetched: state.zone.list.fetched,
      // Organization Info
      org_key: state.organization.info.info.org_key,
      // Metadata Zones
      zones: state.metadata.zone,
      // Date Time Global System
      interval: state.dateTime.interval,
      timezone: state.dateTime.timezone,
      threshold: state.dateTime.threshold,
      endDateTime: state.dateTime.endDateTime,
      startDateTime: state.dateTime.startDateTime
    };
  }
  /**
   * static mapDispatchToProps
   * Binds all the dispatch actions to one object.
   * @param {object} dispatch dispatch callback
   * @return {object} collectiong of dispatch actions
   */
  static mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        // Zone
        getZoneList: zone.list.get
      },
      dispatch
    );
  }
}
/**
 * Export Module (React Component)
 * Wrap module in redux state connect for data and dispatching.
 */
export default connect(Zones.mapStateToProps, Zones.mapDispatchToProps)(Zones);
